import { useState } from "react";
import Card from "@/components/base/Card";
import Badge from "@/components/base/Badge";
import Input from "@/components/base/Input";

export default function ResumenActividadPage() {
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("todos");
  
  const activities = [
    {
      usuario: "Carolina Miranda",
      rol: "Encargada Convivencia",
      fecha: "2026-06-10 10:23",
      detalle: "Cerró el caso FOL-2026-004 de Mateo Silva tras completar plan de intervención escolar.",
      icon: "ri-checkbox-circle-line",
      tipo: "accion",
      caso: "FOL-2026-004"
    },
    {
      usuario: "Daniela Paredes",
      rol: "Psicóloga",
      fecha: "2026-06-10 09:12",
      detalle: "Registró una nueva entrevista confidencial con Isidora Rojas por crisis de ansiedad.",
      icon: "ri-contacts-book-line",
      tipo: "accion",
      caso: "FOL-2026-012"
    },
    {
      usuario: "Sistema IA",
      rol: "IA",
      fecha: "2026-06-10 08:30",
      detalle: "Alerta crítica detectada: Plazo del Tribunal de Familia para enviar informe de Bastián Tapia expira en 48 horas.",
      icon: "ri-error-warning-line",
      tipo: "critico",
      caso: "FOL-2026-009"
    },
    {
      usuario: "Roberto Fuentes",
      rol: "Director",
      fecha: "2026-06-09 16:00",
      detalle: "Ingresó al sistema y descargó el reporte consolidado de desempeño del primer trimestre.",
      icon: "ri-download-cloud-line",
      tipo: "sistema",
      caso: null
    }
  ];

  const filtered = activities.filter(act => {
    if (search && !act.detalle.toLowerCase().includes(search.toLowerCase()) && !act.usuario.toLowerCase().includes(search.toLowerCase())) return false;
    if (filter !== "todos" && act.tipo !== filter) return false;
    return true;
  });

  return (
    <div className="p-4 md:p-6 space-y-6 animate-fade-in-up">
      <div>
        <h1 className="text-xl md:text-2xl font-bold text-foreground-950">Actividad Reciente</h1>
        <p className="text-sm text-foreground-500 mt-0.5">Registro cronológico completo de todas las acciones, derivaciones e intervenciones en la plataforma.</p>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center justify-between">
        <Input
          placeholder="Buscar en el registro..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          icon={<i className="ri-search-line" />}
          className="max-w-sm"
          fullWidth={false}
        />
        <div className="flex gap-2 overflow-x-auto">
          {["todos", "critico", "accion", "sistema"].map((f) => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              className={`px-3.5 py-1.5 rounded-lg text-xs font-semibold border cursor-pointer capitalize transition-all ${
                filter === f
                  ? "bg-foreground-900 text-white border-foreground-900"
                  : "bg-white text-foreground-600 border-background-200 hover:bg-background-50"
              }`}
            >
              {f === "todos" ? "Todos" : f === "critico" ? "⚠️ Críticos" : f === "accion" ? "Acciones" : "Sistema"}
            </button>
          ))}
        </div>
      </div>

      <Card className="relative overflow-hidden">
        <div className="absolute left-[27px] md:left-[35px] top-6 bottom-6 w-0.5 bg-background-200" />
        <div className="space-y-6 relative">
          {filtered.map((act, idx) => (
            <div key={idx} className="flex gap-4 items-start relative animate-fade-in">
              <div className={`w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center border-2 bg-white flex-shrink-0 z-10 ${
                act.tipo === "critico" ? "border-red-300 text-red-600" :
                act.tipo === "accion" ? "border-primary-300 text-text-primary-600" : "border-background-300 text-foreground-400"
              }`}>
                <i className={act.icon} />
              </div>
              <div className="flex-1 bg-background-50/50 hover:bg-background-50 border border-background-200/60 rounded-xl p-4 transition-all">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-1 mb-2">
                  <div className="flex items-center gap-2">
                    <span className="font-semibold text-sm text-foreground-900">{act.usuario}</span>
                    <Badge variant="primary" size="sm">{act.rol}</Badge>
                  </div>
                  <span className="text-xs text-foreground-400 font-medium">{act.fecha}</span>
                </div>
                <p className="text-sm text-foreground-600">{act.detalle}</p>
                {act.caso && (
                  <div className="mt-2 text-xs font-semibold text-text-primary-600 flex items-center gap-1.5">
                    <i className="ri-folder-3-line" />
                    Caso: {act.caso}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
